export const CONTENT_TYPE_HEADER = "content-type";
export const CONTENT_TYPE_JSON = "application/json";